import { ObjectValues } from "types";

const routePaths = {
  BASE: "/",
  LOGIN: "/login",
  LOGOUT: "/logout",
  FORGOT_PASSWORD: "/forgot-password",
  REQUEST_PASSWORD_RESET: "/password/request-reset",
  RESET_PASSWORD: "/password/reset",
  USER_REGISTRATION: "/registration",
  USER_REGISTRATION_CONFIRM: "/registration/confirm",
  TERMS_OF_USE: "/terms",
  CONTRACT: "/contract",
  ABOUT: "/about",
  TARGET: "/targets/:id(\\d+)",
  TARGETS: "/targets",
  DASHBOARD: "/dashboard/:uuid",
  DASHBOARD_DEFAULT: "/dashboard",
  DASHBOARD_SETTINGS: "/dashboard/:uuid/settings",
  HOME: "/home",
  QUESTIONS: "/questions",
  QUESTION: "/questions/:id",
  QUESTION_FEEDS: "/question-feeds",
  QUESTION_FEED_CREATE: "/question-feeds/create",
  QUESTION_FEED_DETAIL: "/question-feeds/:id(\\d+)",
  // Matrix question non admin routes
  MATRIX_QUESTION: "/matrix-questions/:id",
  // Matrix question admin routes
  // NOTE: We moved the admin matrix screens under a `/admin` prefix.
  // We may want to prefix all admin routes with `/admin` in the future.
  // See: https://civicscience.atlassian.net/browse/CS-3879
  MATRIX_QUESTIONS_ADMIN: "/admin/matrix-questions",
  MATRIX_QUESTION_ADMIN_DETAIL: "/admin/matrix-questions/:id",
  MATRIX_QUESTION_ADMIN_CREATE: "/admin/matrix-questions/create",
  WEIGHTING_SCHEME_CREATE: "/admin/weighting-schemes/create",
  WEIGHTING_SCHEME_DETAIL: "/admin/weighting-schemes/:name",
  WEIGHTING_SCHEMES: "/admin/weighting-schemes",
  DEPLOYMENT_SCHEMES: "/admin/deployment-schemes",
  DEPLOYMENT_SCHEME_DETAIL: "/admin/deployment-schemes/:id",
  DEPLOYMENT_SCHEME_THEME: "/admin/deployment-schemes/:id/theme",
  DEPLOYMENT_SCHEME_CREATE: "/admin/deployment-schemes/create",
  SEGMENTS: "/segments",
  SEGMENT: "/segments/:uuid",
  REPORTS: "/reports",
  TOOLKIT: "/admin/toolkit",
  PROFILE: "/profile",
  SCORECARD_DETAIL: "/reports/scorecards/:uuid",
  SCORECARD_CREATE: "/reports/scorecards/create",
  DEEP_PROFILE_CREATE: "/reports/deep-profiles/create",
  DEEP_PROFILE: "/reports/deep-profiles/:uuid",
  MULTI_TIMEVIEW_CREATE: "/reports/multi-timeviews/create",
  MULTI_TIMEVIEW: "/reports/multi-timeviews/:uuid",
  MULTI_SCORE_CREATE: "/reports/multi-scores/create",
  MULTI_SCORE: "/reports/multi-scores/:id(\\d+)",
  // Checkbox non admin routes
  CHECKBOX_QUESTIONS: "/checkbox-questions",
  CHECKBOX_QUESTION: "/checkbox-questions/:id",
  // Checkbox group admin routes
  CHECKBOX_GROUPS: "/admin/checkbox-groups",
  CHECKBOX_GROUP_DETAIL: "/admin/checkbox-groups/:id",
  CHECKBOX_GROUP_CREATE: "/admin/checkbox-groups/create",
  COMPOUND_QUESTIONS_ADMIN: "/admin/compound-questions",
  COMPOUND_QUESTION_CREATE: "/admin/compound-questions/create",
  TAGS: "/admin/tags",
  TAG_DETAIL: "/admin/tags/:id",
  SYSADMIN: "/admin/sysadmin",
  TRENDING_QUESTIONS: "/sysadmin/trending-questions",
  NUGGET_PRESET_TRAIT_BUSINESS: "/admin/nugget-preset-traits",
  STAR_RATING_QUESTIONS: "/admin/star-rating-questions",
  CROSSTABS: "/crosstabs",
  CROSSTAB_CREATE: "/crosstabs/create",
  CROSSTAB: "/crosstabs/:id",
  CROSSTAB_CREATE_POC: "/reports/crosstab-poc/create",
} as const;

// Union of string literals representing our route paths
export type RoutePathType = ObjectValues<typeof routePaths>;

export default routePaths;
